<template>
  <div class="module_exemplary-data">
    <h3>{{ $t("shop_personalisierbar") }}</h3>
    <div>
      <div class="exemplartexte-list" :key="text.NameImEntwurf" v-for="text in product.editableTextGroups">
        <div class="exemplartexte-part">{{ text.Part }}</div>
        <input class="exemplartexte-value" type="text" name="Textvalue" v-model="text.value" id="textValueID">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExemplaryData",
  props: {
    product: Object
  }
}
</script>

<style lang="scss" scoped>
.module_exemplary-data {
  h3 {
    font-weight: 600;
  }
}

.team-product-select {
  width: 100%;
  margin-bottom: 15px;
}

.exemplartexte-list {
  width: 900px;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  width: 400px;
}

.exemplartexte-part {
  width: 50%;
  padding-top: 5px;
}

.exemplartexte-inhalt {
  width: 20%;
  padding-top: 5px;
}

.exemplartexte-value {
  width: calc(50% - 15px);
  border: 1px solid $color-grey;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30px;
  cursor: pointer;
  padding-left: 10px;
}

.error {
  color: $color-red;
  font-size: 12px;
  display: block;
  line-height: 16px;
}

</style>
